/** Copyright © 2024 Qcells. All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized use,
 * duplication, or distribution of software is strictly prohibited.
 */
import { HISTORY_INFO_CHANGE_TYPE_CODE } from '@hems/util/src/constant';
export const isNotDeleteChangedTypeCode = (history) => history.change_type_cd !== HISTORY_INFO_CHANGE_TYPE_CODE.DELETE;
export const isNotUpdateChangedTypeCode = (history) => history.change_type_cd !== HISTORY_INFO_CHANGE_TYPE_CODE.UPDATE;
